import RequestAbstract from "./RequestAbstract";

export default class MedSection extends RequestAbstract {

    get link() {
        return this.links.medSection;
    }

    getInfoMedSection(id) {
        return this.get(this.links.medSection + "/details/" + id);
    }
}
